import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Routes from 'shared/enums/routes';

const SignoutRedirect = () => {
  const logoutChannel = new BroadcastChannel('logout');

  useEffect(() => {
    logoutChannel.postMessage('logout');
  }, []);

  return <Navigate to={Routes.Login} replace />;
};

export default SignoutRedirect;
